import { AdminSettingsSectionShell } from "../AdminSettingsSectionShell";
import { CountryMultipliersSection } from "./CountryMultipliersSection";
import { ServicePriceLimitsSection } from "./ServicePriceLimitsSection";
import { PayoutRequestMinSection } from "./PayoutRequestMinSection";

export function PricingSection() {
  return (
    <AdminSettingsSectionShell
      title="Cijene"
      description="Regionalni multiplikatori žive uz platform fee pregled, jer zajedno mijenjaju javnu cijenu rezervacije."
    >
      <div className="flex flex-col gap-4">
        <ServicePriceLimitsSection />
        <PayoutRequestMinSection />
        <CountryMultipliersSection />
      </div>
    </AdminSettingsSectionShell>
  );
}
